import React from "react";

const TAB_BACKGROUNDS = {
  home: {
    base: "linear-gradient(180deg, #030303 0%, #070605 24%, #120C08 56%, #2D1E11 100%)",
    mesh: [
      "radial-gradient(circle at 16% 14%, rgba(245, 158, 11, 0.28) 0%, rgba(245, 158, 11, 0.08) 18%, transparent 44%)",
      "radial-gradient(circle at 84% 18%, rgba(250, 204, 21, 0.12) 0%, rgba(245, 158, 11, 0.04) 16%, transparent 36%)",
      "radial-gradient(circle at 78% 76%, rgba(176, 103, 19, 0.16) 0%, rgba(122, 68, 16, 0.05) 18%, transparent 40%)",
      "radial-gradient(circle at 20% 84%, rgba(214, 119, 22, 0.14) 0%, rgba(92, 49, 12, 0.03) 20%, transparent 38%)",
    ].join(", "),
    sheen: "linear-gradient(125deg, rgba(255,244,225,0.05) 0%, rgba(255,244,225,0.01) 28%, rgba(245,158,11,0.06) 70%, rgba(0,0,0,0) 100%)",
    orbA: "radial-gradient(circle, rgba(249,186,75,0.3) 0%, rgba(245,158,11,0.09) 42%, transparent 72%)",
    orbB: "radial-gradient(circle, rgba(212,140,49,0.24) 0%, rgba(112,65,14,0.06) 44%, transparent 72%)",
    orbC: "radial-gradient(circle, rgba(255,214,122,0.12) 0%, rgba(245,158,11,0.03) 48%, transparent 72%)",
  },
  chat: {
    base: "linear-gradient(180deg, #030303 0%, #090705 26%, #150E09 58%, #342617 100%)",
    mesh: [
      "radial-gradient(circle at 18% 16%, rgba(232, 173, 73, 0.26) 0%, rgba(232, 173, 73, 0.08) 18%, transparent 44%)",
      "radial-gradient(circle at 82% 16%, rgba(103, 151, 176, 0.16) 0%, rgba(43, 90, 111, 0.05) 18%, transparent 38%)",
      "radial-gradient(circle at 74% 80%, rgba(183, 128, 53, 0.16) 0%, rgba(102, 69, 28, 0.05) 20%, transparent 42%)",
      "radial-gradient(circle at 14% 86%, rgba(245, 190, 102, 0.1) 0%, rgba(87, 56, 24, 0.03) 18%, transparent 38%)",
    ].join(", "),
    sheen: "linear-gradient(128deg, rgba(255,243,224,0.04) 0%, rgba(28,48,59,0.03) 32%, rgba(222,167,84,0.06) 76%, rgba(0,0,0,0) 100%)",
    orbA: "radial-gradient(circle, rgba(234,181,93,0.28) 0%, rgba(186,126,45,0.08) 42%, transparent 74%)",
    orbB: "radial-gradient(circle, rgba(86,128,152,0.16) 0%, rgba(45,73,89,0.05) 44%, transparent 72%)",
    orbC: "radial-gradient(circle, rgba(210,163,82,0.12) 0%, rgba(112,77,28,0.03) 50%, transparent 74%)",
  },
  insights: {
    base: "linear-gradient(180deg, #030303 0%, #080705 24%, #130D09 54%, #322314 100%)",
    mesh: [
      "radial-gradient(circle at 22% 14%, rgba(246, 181, 74, 0.28) 0%, rgba(246, 181, 74, 0.08) 18%, transparent 44%)",
      "radial-gradient(circle at 78% 18%, rgba(248, 220, 154, 0.14) 0%, rgba(210, 164, 82, 0.04) 16%, transparent 38%)",
      "radial-gradient(circle at 76% 76%, rgba(186, 129, 47, 0.18) 0%, rgba(93, 61, 21, 0.05) 18%, transparent 40%)",
      "radial-gradient(circle at 16% 82%, rgba(134, 99, 42, 0.12) 0%, rgba(76, 52, 18, 0.03) 18%, transparent 38%)",
    ].join(", "),
    sheen: "linear-gradient(122deg, rgba(255,247,233,0.05) 0%, rgba(255,247,233,0.01) 26%, rgba(214,164,82,0.06) 72%, rgba(0,0,0,0) 100%)",
    orbA: "radial-gradient(circle, rgba(243,184,79,0.3) 0%, rgba(190,135,54,0.08) 42%, transparent 74%)",
    orbB: "radial-gradient(circle, rgba(181,131,53,0.2) 0%, rgba(94,64,25,0.05) 44%, transparent 72%)",
    orbC: "radial-gradient(circle, rgba(251,231,179,0.1) 0%, rgba(190,135,54,0.03) 48%, transparent 74%)",
  },
  profile: {
    base: "linear-gradient(180deg, #030303 0%, #080706 22%, #120D0B 52%, #2D211B 100%)",
    mesh: [
      "radial-gradient(circle at 18% 14%, rgba(226, 176, 99, 0.2) 0%, rgba(226, 176, 99, 0.07) 16%, transparent 42%)",
      "radial-gradient(circle at 82% 18%, rgba(190, 135, 86, 0.13) 0%, rgba(112, 69, 48, 0.04) 16%, transparent 36%)",
      "radial-gradient(circle at 74% 76%, rgba(171, 104, 75, 0.16) 0%, rgba(94, 56, 41, 0.05) 18%, transparent 40%)",
      "radial-gradient(circle at 18% 84%, rgba(243, 211, 165, 0.09) 0%, rgba(114, 82, 54, 0.03) 18%, transparent 38%)",
    ].join(", "),
    sheen: "linear-gradient(125deg, rgba(255,245,230,0.05) 0%, rgba(255,245,230,0.01) 28%, rgba(214,161,111,0.06) 72%, rgba(0,0,0,0) 100%)",
    orbA: "radial-gradient(circle, rgba(231,183,118,0.24) 0%, rgba(179,123,76,0.08) 42%, transparent 72%)",
    orbB: "radial-gradient(circle, rgba(176,118,89,0.16) 0%, rgba(102,61,43,0.05) 44%, transparent 72%)",
    orbC: "radial-gradient(circle, rgba(248,231,204,0.1) 0%, rgba(179,123,76,0.03) 48%, transparent 72%)",
  },
};

export const BreathingBackground = ({ activeTab = "home" }) => {
  const palette = TAB_BACKGROUNDS[activeTab] || TAB_BACKGROUNDS.home;

  return (
    <div
      data-testid="breathing-background"
      className="fixed inset-0 pointer-events-none z-0"
      style={{ willChange: "opacity, transform" }}
    >
      <div
        className="absolute inset-[-12%]"
        style={{
          background: palette.base,
          animation: "backgroundBloom 20s ease-in-out infinite alternate",
          willChange: "opacity, transform",
        }}
      />
      <div
        className="absolute inset-[-18%]"
        style={{
          backgroundImage: palette.mesh,
          backgroundSize: "138% 138%",
          backgroundPosition: "0% 0%",
          animation: "meshShift 24s ease-in-out infinite alternate",
          opacity: 0.92,
          willChange: "opacity, transform, background-position",
        }}
      />
      <div
        className="absolute inset-[-14%]"
        style={{
          background: palette.sheen,
          opacity: 0.74,
          animation: "slowPan 28s ease-in-out infinite alternate",
          willChange: "opacity, transform",
        }}
      />
      <div
        className="absolute -left-24 -top-24 h-[27rem] w-[27rem] rounded-full"
        style={{
          background: palette.orbA,
          animation: "breatheGradient 14s ease-in-out infinite",
          willChange: "opacity, transform",
        }}
      />
      <div
        className="absolute bottom-[-10rem] right-[-8rem] h-[24rem] w-[24rem] rounded-full"
        style={{
          background: palette.orbB,
          animation: "orbitalDrift 17s ease-in-out infinite",
          willChange: "opacity, transform",
        }}
      />
      <div
        className="absolute left-1/2 top-[28%] h-[20rem] w-[20rem] -translate-x-1/2 rounded-full"
        style={{
          background: palette.orbC,
          animation: "ambientLift 16s ease-in-out infinite",
          willChange: "opacity, transform",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 44%, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.16) 58%, rgba(0,0,0,0.48) 100%)",
        }}
      />
    </div>
  );
};

export default BreathingBackground;
